window.theme.component('grupos-whatsapp-modal', el => {
	// The modal homes elsewhere in the DOM (component() output is passed as
	// the modal's 'html'), so the element carrying the 'open'/'close' events
	// is an ancestor, not this one.
	const modal = el.closest('.js-modal');
	const revertUrl = el.dataset.revertUrl || '';

	if (modal && revertUrl) {
		// Visited via /grupos (no real page behind it, see app/whatsapp-groups.php):
		// closing shouldn't leave the address bar stuck on a path with
		// nothing of its own, so it reverts to the home URL it's actually
		// showing underneath.
		modal.addEventListener('close', () => {
			window.history.pushState(null, '', revertUrl);
		});
	}

	const params = new URLSearchParams(window.location.search);
	const shouldAutoOpen = params.get('modal') === 'grupos' || el.dataset.autoOpen === '1';
	if (!shouldAutoOpen) return;

	// Deferred so it runs after every component's init pass this tick,
	// including modal's own (which is what sets
	// window.theme.components.modal.open): component registration order
	// isn't guaranteed to put this one last.
	setTimeout(() => {
		if (window.theme.components.modal && window.theme.components.modal.open) {
			window.theme.components.modal.open('modal-grupos-whatsapp');
		}
	}, 0);
});
